<template>
    <div class="iconPicker">
        <div class="ip-tabs" v-if="!iconOnly">
            <span class="ip-tab" :class="{ active: activeTab === 'emoji' }" @click="activeTab = 'emoji'">{{ $t('dash.post-creator.media-editor.icon-picker.tab-emoji') }}</span>
            <span class="ip-tab" :class="{ active: activeTab === 'fa' }" @click="activeTab = 'fa'">{{ $t('dash.post-creator.media-editor.icon-picker.tab-icons') }}</span>
        </div>

        <div class="ip-search">
            <i class="fa-solid fa-magnifying-glass"></i>
            <input type="text" v-model="query" :placeholder="$t('dash.post-creator.media-editor.icon-picker.search-placeholder')" @click.stop>
        </div>

        <div class="ip-groups">
            <div class="ip-group">
                <p class="ip-group-title">{{ $t('dash.post-creator.media-editor.icon-picker.none') }}</p>
                <div class="ip-grid">
                    <span class="ip-none" :class="{ active: !value }" @click="$emit('select', '')">
                        <i class="fa-solid fa-ban"></i>
                    </span>
                </div>
            </div>

            <div class="ip-group" v-if="query">
                <p class="ip-group-title">{{ $t('dash.post-creator.media-editor.icon-picker.results') }}</p>
                <p class="ip-empty" v-if="!filteredResults.length">{{ $t('dash.post-creator.media-editor.icon-picker.no-results') }}</p>
                <div class="ip-grid" v-else-if="activeTab === 'emoji'">
                    <span
                        v-for="item in filteredResults"
                        :key="item.char"
                        class="ip-emoji"
                        :class="{ active: isSelected('emoji', item.char) }"
                        @click="selectEmoji(item.char)"
                    >{{ item.char }}</span>
                </div>
                <div class="ip-grid" v-else>
                    <span
                        v-for="item in filteredResults"
                        :key="item.name"
                        class="ip-fa-icon"
                        :class="{ active: isSelected('fa', item.name) }"
                        @click="selectFa(item.name)"
                    ><i class="fa-solid" :class="'fa-' + item.name"></i></span>
                </div>
            </div>

            <template v-else-if="activeTab === 'emoji'">
                <div class="ip-group" v-for="group in emojiGroups" :key="group.labelKey">
                    <p class="ip-group-title">{{ $t(group.labelKey) }}</p>
                    <div class="ip-grid">
                        <span
                            v-for="item in group.items"
                            :key="item.char"
                            class="ip-emoji"
                            :class="{ active: isSelected('emoji', item.char) }"
                            @click="selectEmoji(item.char)"
                        >{{ item.char }}</span>
                    </div>
                </div>
            </template>

            <template v-else>
                <div class="ip-group">
                    <div class="ip-grid">
                        <span
                            v-for="item in faIcons"
                            :key="item.name"
                            class="ip-fa-icon"
                            :class="{ active: isSelected('fa', item.name) }"
                            @click="selectFa(item.name)"
                        ><i class="fa-solid" :class="'fa-' + item.name"></i></span>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { EMOJI_GROUPS } from '../engine/emojiList.js'
import { FA_ICONS } from '../engine/faIconList.js'

export default {
    name: 'IconPicker',

    props: {
        // '' (none), or { type: 'emoji'|'fa', value: <char or FA icon name> }
        value: {
            type: [Object, String],
            default: ''
        },
        // when true, only the FontAwesome icon tab is shown (no emoji tab/picker)
        iconOnly: {
            type: Boolean,
            default: false
        },
        // optional alternate FA icon set (defaults to the video editor's curated list)
        faIcons: {
            type: Array,
            default: () => FA_ICONS
        }
    },

    data() {
        return {
            query: '',
            activeTab: this.iconOnly || (this.value && this.value.type === 'fa') ? 'fa' : 'emoji',
            emojiGroups: EMOJI_GROUPS,
        }
    },

    computed: {
        filteredResults() {
            const q = this.query.trim().toLowerCase()
            if (!q) return []
            const source = this.activeTab === 'emoji' ? this.emojiGroups.flatMap(g => g.items) : this.faIcons
            return source.filter(item => item.keywords.includes(q) || (item.name && item.name.includes(q)))
        }
    },

    methods: {
        isSelected(type, val) {
            return !!this.value && this.value.type === type && this.value.value === val
        },

        selectEmoji(char) {
            this.$emit('select', { type: 'emoji', value: char })
        },

        selectFa(name) {
            this.$emit('select', { type: 'fa', value: name })
        }
    }
}
</script>

<style lang="scss" scoped></style>
